import React, { useEffect, useState } from "react";
import "./Footer.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import getStoredData from "../../json/fetchData";
import { Link } from "react-router-dom";

const Footer = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const stored = getStoredData();
    setData(stored?.["7"]);
  }, []);

  if (!data) return null;

  return (
    <footer className="footer-container">
      <div className="footer-top">
        <div className="footer-top-inner">
          {data.columns.map((col, idx) => (
            <div className="footer-column" key={idx}>
              <h4>{col.title}</h4>

              {/* Render internal links */}
              {col.items?.map((item, i) => {
                if (typeof item === "string") {
                  return <p key={i}>{item}</p>;
                } else if (
                  typeof item === "object" &&
                  item.title &&
                  item.link
                ) {
                  return (
                    <p key={i}>
                      <Link to={item.link} className="footer-link">
                        {item.title}
                      </Link>
                    </p>
                  );
                }
                return null;
              })}

              {/* Address block with optional Google Maps link */}
              {col.addressLines && typeof col.addressLines === "string" && (
                <p>
                  {col.addressLink ? (
                    <a
                      href={col.addressLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-link"
                    >
                      {col.addressLines.split(",").map((line, i, arr) => (
                        <span key={i}>
                          {line.trim()}
                          {i !== arr.length - 1 && <br />}
                        </span>
                      ))}
                    </a>
                  ) : (
                    col.addressLines.split(",").map((line, i, arr) => (
                      <span key={i}>
                        {line.trim()}
                        {i !== arr.length - 1 && <br />}
                      </span>
                    ))
                  )}
                </p>
              )}

              {/* Phone clickable with tel: */}
              {col.phone && (
                <p>
                  <a
                    href={`tel:${col.phone.replace(/\s+/g, "")}`}
                    className="footer-link"
                  >
                    {col.phone}
                  </a>
                </p>
              )}

              {/* Email clickable with mailto: */}
              {col.email && (
                <p>
                  <a href={`mailto:${col.email}`} className="footer-link">
                    {col.email}
                  </a>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>

<div className="footer-bottom">
  <p>{data?.copyright || "© 2025 Your Company — All rights reserved."}</p>

  <div className="footer-icons">
    {data.socialLinks?.map((link, i) => (
      <Link
        key={i}
        to={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-icon"
      >
        <i className={`fa-brands fa-${link.platform}`}></i>
      </Link>
    ))}
  </div>
</div>

{/* ✅ New Created By Section */}
<div className="footer-createdby">
  <p>
    {data?.createdBy || "Website Designed & Maintained by"}{" "}
    <a
      href={data?.LinkCompany || "https://axiomos.in/"}
      target="_blank"
      rel="noopener noreferrer"
      className="footer-link"
    >
      {data?.linktext || "AXIOMOS"}
    </a>
  </p>
</div>

    </footer>
  );
};

export default Footer;
